import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import { Switch, Route, withRouter } from 'react-router-dom';
import {Container, Row, Col} from 'react-bootstrap';
import {initializeApp} from './actions/app';
import { ARRANGEMENT_TYPE_SLUG } from '../config';
import 'react-confirm-alert/src/react-confirm-alert.css';

import TopMenu from './components/TopMenu.jsx';
import Menu from './components/Menu.jsx';
import Login from './components/Login/Login.jsx';
import Home from './components/Home/Home.jsx';

import Profile from './components/Settings/Profile/Profile.jsx';
import SalesAgree from './components/Settings/SalesAgree.jsx';
import PasswordChange from './components/Settings/PasswordChange/PasswordChange.jsx';
import DeleteCard from './components/Settings/DeleteCard.jsx';
import DeleteSubscription from './components/Settings/DeleteSubscription.jsx';
import PaymentData from './components/Settings/PaymentData/PaymentData.jsx';
import PaymentDataCreateForm from './components/Settings/PaymentData/PaymentDataCreateForm.jsx';
import PaymentDataUpdateForm from './components/Settings/PaymentData/PaymentDataUpdateForm.jsx';

import Aphorisms from './components/Aphorisms/Aphorisms.jsx';
import AphorismsForm from './components/Aphorisms/AphorismsForm.jsx';
import Notifications from './components/Notifications/Notifications.jsx';
import Favorites from './components/Favorites/Favorites.jsx';
import Coupons from './components/Coupons/Coupons.jsx';
import Purchases from './components/Purchases/Purchases.jsx';
import PurchasesArrangements from './components/Purchases/PurchasesArrangements.jsx';
import Cart from './components/Cart/Cart.jsx';
// import Comments from './components/Comments/Comments.jsx';
import Offers from './components/Offers/Offers.jsx';
import OffersCreateForm from './components/Offers/OffersCreateForm.jsx';
import OffersUpdateForm from './components/Offers/OffersUpdateForm.jsx';
import ModeratorOffers from './components/Moderator/ModeratorOffers.jsx';
import ModeratorOffersUpdateForm from './components/Moderator/ModeratorOffersUpdateForm.jsx';
import DepartmentComponent from './components/DepartmentMainPage.jsx';

import CollectionArrangements from './components/Collection/Arrangements/CollectionArrangements.jsx';
import CollectionPlaylists from './components/Collection/Playlists/CollectionPlaylists.jsx';
import CollectionPlaylistArrangements from './components/Collection/Playlists/CollectionPlaylistArrangements.jsx';
import CollectionAuthors from './components/Collection/Authors/CollectionAuthors.jsx';
import CollectionAuthorsArrangements from './components/Collection/Authors/CollectionAuthorArrangements.jsx';
import CollectionGenres from './components/Collection/Genres/CollectionGenres.jsx';
import CollectionGenresArrangements from './components/Collection/Genres/CollectionGenresArrangements.jsx';


export const LangContext = React.createContext('ru');

class App extends React.Component {
  componentDidMount() {
    this.props.initializeApp();
  }

  render() {
    if (!this.props.isInitialized) return <div>{ gettext('Загрузка...') }</div>;
    const root = '/:lang/my/';
    return (
      <LangContext.Provider value={ this.props.lang }>
      <TopMenu/>
      <Container fluid>
        <Row>
          <Col lg={9} md={8} sm={12}>
            <Switch>
              {/* https://github.com/pillarjs/path-to-regexp/tree/v1.7.0 */}
              <Route exact path={ root + 'login/' } component={ Login }/>
              <Route exact path={ root + 'home/' } component={ Home }/>
              <Route exact path={ root } component={ Home }/>

              <Route exact path={ root + 'settings/'} component={ DepartmentComponent }/>
              <Route exact path={ root + 'settings/profile/'} component={ Profile }/>
              <Route exact path={ root + 'settings/sales-agree/'} component={ SalesAgree }/>
              <Route exact path={ root + 'settings/password-change/'} component={ PasswordChange }/>
              <Route exact path={ root + 'settings/delete-card/'} component={ DeleteCard }/>
              <Route exact path={ root + 'settings/delete-subscription/'} component={ DeleteSubscription }/>
              <Route exact path={ root + 'settings/payment-data/'} component={ PaymentData }/>
              <Route exact path={ root + 'settings/payment-data/create/'} component={ PaymentDataCreateForm }/>
              <Route exact path={ root + 'settings/payment-data/:id/'} component={ PaymentDataUpdateForm }/>

              <Route path={ root + 'notifications/' } component={ Notifications }/>
              <Route path={ root + 'favorites/' } component={ Favorites }/>
              <Route path={ root + 'coupons/' } component={ Coupons }/>
              <Route path={ root + 'cart/' } component={ Cart }/>
              <Route exact path={ root + 'purchases/' + ARRANGEMENT_TYPE_SLUG + '/' } component={ PurchasesArrangements }/>
              <Route path={ root + 'purchases/:type*/' } component={ Purchases }/>

              <Route exact path={ root + 'content/' } component={ DepartmentComponent }/>
              <Route exact path={ root + 'content/aphorisms/' } component={ Aphorisms }/>
              <Route exact path={ root + 'content/aphorisms/create/' } component={ AphorismsForm }/>
              <Route exact path={ `${root}content/:type/` } component={ Offers }/>
              <Route exact path={ `${root}content/:type/create/` } component={ OffersCreateForm }/>
              <Route exact path={ `${root}content/:type/:id/` } component={ OffersUpdateForm }/>

              <Route exact path={ root + 'collection/'} component={ DepartmentComponent }/>
              <Route exact path={ root + 'collection/' + ARRANGEMENT_TYPE_SLUG + '/'} component={ CollectionArrangements }/>
              <Route exact path={ root + 'collection/playlists/'} component={ CollectionPlaylists }/>
              <Route exact path={ root + 'collection/playlists/:id/'} component={ CollectionPlaylistArrangements }/>
              <Route exact path={ root + 'collection/authors/'} component={ CollectionAuthors }/>
              <Route exact path={ root + 'collection/authors/:slug/'} component={ CollectionAuthorsArrangements }/>
              <Route exact path={ root + 'collection/genres/'} component={ CollectionGenres }/>
              <Route exact path={ root + 'collection/genres/:slug/'} component={ CollectionGenresArrangements }/>

              { this.props.is_moderator && <>
                <Route exact path={ root + 'moderator/'} component={ DepartmentComponent }/>
                <Route exact path={ `${root}moderator/:type/` } component={ ModeratorOffers }/>
                <Route exact path={ `${root}moderator/:type/:id/` } component={ ModeratorOffersUpdateForm }/>
              </> }

              {/*<Route path={root + 'comments/'} component={Comments}/>*/}
            </Switch>
          </Col>
          <Col lg={3} md={4} className="d-none d-md-block">
            <Menu/>
          </Col>
        </Row>
      </Container>
      </LangContext.Provider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isInitialized: state.app.isInitialized,
    is_moderator: state.auth.is_moderator,
    isAuth: state.auth.isAuth,
    lang: state.auth.lang
  }
};

export default compose(
  withRouter,
  connect(mapStateToProps, { initializeApp }),
)(App)

